import cn from 'classnames';
import { forwardRef, HTMLProps } from 'react';
import { SizeType, VariantType } from '../../types/props';
import s from './radio-button.module.css';

export interface RadioButtonProps extends Omit<HTMLProps<HTMLInputElement>, 'size'> {
  size?: SizeType;
  variant?: VariantType;
  label?: string;
  subLabel?: string;
  onClick?: () => void;
  checked?: boolean;
}

export const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>((props, ref) => {
  const {
    size = 'md',
    variant = 'primary',
    className,
    label,
    subLabel,
    onClick,
    checked = false,
    disabled,
    ...other
  } = props;

  const classNames = cn(s.input, className, s[variant]);

  return (
    <div
      className={cn(s.component, disabled && s.disabled)}
      tabIndex={disabled ? -1 : 0}
      data-testid="radio-wrapper"
    >
      <div className={s.base} onClick={onClick} data-testid="radio-base">
        <input
          {...other}
          ref={ref}
          className={classNames}
          type="radio"
          checked={checked}
          onChange={(e) => {
            e.preventDefault();
            onClick?.();
          }}
          data-testid="radio-input"
        />
        <span
          data-testid="custom-radio"
          className={cn(s.customRadio, checked && s.checked, s[size])}
        />
        {label}
      </div>
      {subLabel}
    </div>
  );
});
